<template>
    <el-dialog
      :visible.sync="show"
      width="50%"
      title="设置客服"
      :close-on-click-modal="false"
    >
      <el-form :inline="true">
        <el-form-item label="名称">
          <el-input v-model="name" placeholder="名称"></el-input>
        </el-form-item>
        <el-form-item label="登录账号">
          <el-input v-model="login_name" placeholder="登录账号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList(1)">搜索</el-button>
        </el-form-item>
      </el-form>
      <auto-table
        :DataList="DataList"
        :option="Option"
        :total="Total"
        @changePage="getList"
      >
        <template #grade="{ row }">
          <div>
            {{ row.platform }}
          </div>
        </template>
        <template #handler="{ row }">
          <div>
            <el-button type="primary" size="small" @click="change(row)"
              >成为客服</el-button
            >
          </div>
        </template>
      </auto-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="show = false">关 闭</el-button>   
      </span>
    </el-dialog>

</template>

<script>
export default {
  data() {
    return {
      DataList: [],
      Option: [
        { name: "名称", value: "name" },
        { name: "登录账号", value: "login_name" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      status: 1,
      show: false,
      name: '',
      login_name: ''
    };
  },

  methods: {
    open() {
      this.show = true;
    },
    change(row){
        this.$confirm('确定将该员工设置为客服？').then(res=>{
            let data = {
                user_id: 'hcs' + row.id,
                name: row.name
            }
            this.$post('/chat/imUser/setCustomerService',data).then(res=>{
                this.show = false
               this.$notify({
                  title: '添加成功',
                  message: '去设置客服的服务平台和内容吧',
                  type: 'success'
                });
                this.$emit('success',{})
            })
        })
    },
    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/authorization/managerUser/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          name: this.name || null,
          login_name: this.login_name || null
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>